import React, { useEffect, useState } from "react";
import axios from "axios";
// import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import {Notification} from "../../Notification"
import Cookies from "js-cookie";
const EarlyCODModal = ({ isOpen, onClose,userId }) => {
  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const [plans, setPlans] = useState("");
  const { id } = useParams();
  console.log("id in early cod popup", id);

  if (!isOpen) return null;
  const params = {
    id: userId || id,
  }
  // Fetch the user's current COD plan
  const check = async () => {
    try {

      const token = Cookies.get("session");
      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/cod/CheckCodplan`,
        { params, headers: { Authorization: `Bearer ${token}` } }
      );
      // setPlans(response.data.codplaneName);
      setPlans(String(response.data.codplaneName));

      // console.log("kkkkk",response.data.codplaneName)// Store the current plan
    } catch (error) {
      console.error("Error fetching COD plan:", error);
    }
  };

  check();


  // Function to activate a new COD plan
  const handleActivate = async (planName, codAmount) => {
    try {
      const token = Cookies.get("session");
      const response = await axios.post(
        `${REACT_APP_BACKEND_URL}/cod/codPlanUpdate`,
        { planName, codAmount },
        { params,headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        Notification(`Successfully activated ${planName} plan!`,"success");
        setPlans(planName); // Update the plan immediately after activation
      }
    } catch (error) {
      console.error("Error activating plan:", error);
      Notification("Failed to activate plan. Please try again.","error");
    }
  };

  // List of available plans
  const codPlans = [
    { name: "D+1", amount: 1.5, label: "D + 1 Days", bg: "bg-gradient-to-b from-[#6a5b75] to-[#2d054b] text-white" },
    { name: "D+2", amount: 0.99, label: "D + 2 Days", bg: "bg-white border border-gray-300 text-gray-500" },
    { name: "D+3", amount: 0.7, label: "D + 3 Days", bg: "bg-white border border-gray-300 text-gray-500" },
    { name: "D+4", amount: 0.5, label: "D + 4 Days", bg: "bg-white border border-gray-300 text-gray-500" },
  ];

  return (
    <div className="fixed inset-0 flex items-center bg-gray-700 justify-center bg-opacity-50 px-2 overflow-y-auto mt-16 z-50">
      <div className="bg-white rounded-lg p-4 w-full max-w-[90%] md:max-w-[70%] lg:max-w-[55%] xl:max-w-[65%] relative max-h-[90vh] overflow-y-auto">
        {/* Close Button */}
        <button
          className="absolute top-3 right-3 text-gray-500 text-[18px]"
          onClick={onClose}
        >
          &times;
        </button>

        {/* Header Section */}
        <div className="text-center">
          <h2 className="text-[12px] sm:text-[18px] font-[600] text-gray-700">Get Early COD</h2>
          <p className="text-gray-600 text-[12px] sm:text-[16px]">
            Why Wait? Scale your business with <b>Daily COD remittance</b>
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-4">
          {codPlans.map((plan) => (
            <div key={plan.name} className={`p-4 rounded-lg shadow-md flex flex-col ${plan.bg}`}>
              {plan.name === "D+1" && (
                <div className="bg-yellow-400 text-[12px] sm:text-[14px] font-[600] px-2 py-1 rounded-lg w-fit mb-2">
                  MOST POPULAR
                </div>
              )}
              <h3 className="text-[12px] font-[600] sm:text-[14px]">{plan.label}</h3>
              <p className="text-[14px] font-[600] sm:text-[16px]">{plan.amount}%</p>
              <p className="text-[12px] sm:text-[14px]">Of COD Amount</p>
              <ul className="text-[12px] sm:text-[14px] mt-2 flex-grow">
                <li>✅ Guaranteed Remit in {plan.name.split("+")[1]} days</li>
                <li>✅ Steady Cash Flow</li>
              </ul>
              <button
                className={`w-full py-2 text-[12px] sm:text-[14px] font-[600] mt-3 rounded-lg ${plans === plan.name
                  ? "bg-gray-400 cursor-not-allowed text-white"
                  : "bg-purple-500 text-white"
                  }`}
                onClick={() => handleActivate(plan.name, plan.amount)}
                disabled={plans === plan.name}
              >
                {plans === plan.name ? "Activated" : "Activate"}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EarlyCODModal;
